<template ref="childRef2">
    <div class="users-settings">
        <!-- <div class="title-section">
                <div class="left">
                    <h2>Liste des utilisateurs</h2>
                    <p>Consulté et gérer vos utilisateurs</p>
                </div>               
        </div> -->
        <div class="container-search">
            <div class="left">
                <div class="seach-bar">
                    <div class="container-svg-serach">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#AB6E93"/>
                        </svg>
                    </div>
                    <input v-model="valueInputSearch" :placeholder="$t('dash.placeholder.search')">
                </div>
            </div>
            <div class="right">
                <div v-if="SelectUser.length > 0" class="btn-outline-primary icon-l" @click="removeUserSelected"><i class="fa-regular fa-trash-can"></i><span>{{ $t("dash.button.delete") }}</span></div>
                <div class="btn-primary icon-l" @click.stop="startAddUser"><i class="fa-solid fa-user-plus"></i><span>{{ $t("dash.settings.users.header.add_user") }}</span></div>
            </div>
        </div>
        <div class="container-list-user">
            <div class="legend">
                <div>
                    <Checkbox :id="'selectAllUser'" :isChecked="SelectUser.length >= 1" :isLine="SelectUser.length < users.length  && SelectUser.length >= 1" :isDisable="users.length == 0" :add="addAllUser" :remove="removeAllUser"></Checkbox>
                    <p :class="{active : sortBy=='email', sort:true}" @click="setSortBy('email')">{{ $t("dash.settings.users.legend.email") }}<i class="fa-solid fa-caret-down" ></i></p>
                </div>
                <p :class="{lastname: true, active : sortBy=='lastname', sort:true}" @click="setSortBy('lastname')">{{ $t("dash.settings.users.legend.last_name") }}<i class="fa-solid fa-caret-down" ></i></p>
                <p :class="{firstname: true, active : sortBy=='firstname', sort:true}" @click="setSortBy('firstname')">{{ $t("dash.settings.users.legend.first_name") }}<i class="fa-solid fa-caret-down" ></i></p>
                <p :class="{role: true, active : sortBy=='role', sort:true}" @click="setSortBy('role')">{{ $t("dash.settings.users.legend.role") }}<i class="fa-solid fa-caret-down"></i></p>
                <p class="page">Pages</p>
            </div>
            <div class="user" v-for="user in getUsersBySort" :key="user.id">
                <div class="user-name">
                    <Checkbox :id="user.id" :isChecked="SelectUser.includes(user.id)" :add="addSelectUser" :remove="removeSelectUser"></Checkbox>
                    <label :for="user.id"><p>{{ user.email }}</p></label>
                    <div v-if="!user.confirmed_at" class="badge-outline-r" ><i class="fa-solid fa-paper-plane"></i>{{ $t("dash.status.inqueue") }}</div>
                    <Tooltip v-if="mfaEnabled && user.mfa && (user.mfa.enabled || user.mfa.required)" :text="user.mfa.enabled ? $t('mfa.status.enabled') : $t('mfa.users.required_pending')">
                        <i :class="['fa-solid', 'mfa-user-icon', user.mfa.enabled ? 'fa-shield-check on' : 'fa-shield-halved pending']"></i>
                    </Tooltip>
                </div>
                <p class="lastname color-grey">{{ user.lastname }}</p>
                <p class="firstname color-grey">{{ user.firstname }}</p>

                <p class="role color-grey">
                    {{ user.admin ==true ? $t("dash.settings.user.Administrator")+' ' : user.role && user.role.length > 0 ? '' : $t("dash.settings.user.Editor")+' '}}
                    
                    <template v-for="r in user.role">
                        {{ $t("dash.settings.user."+r) + ' '}}
                    </template>


                    <span class="copyLink" v-if="user.role && user.role.includes('Viewer')" @click="getViewerLoginUrl(user.id)">
                        <Tooltip :text="'Copier le lien'">
                            <i class="fa-solid fa-link"></i>
                        </Tooltip>
                    </span>
                   
                </p>

                <div class="listPages">
             
                    
                    <div class="containerAvatar" v-for="page in getInfoAvatars(user.pages_access).slice(0,4)" :key="page.id" @click.stop="addPage(user.id)">
                        <Avatar :toggleDisplayReseau="true" :typeNetwork=page.network :urlPicture=page.avatar></Avatar>
                    </div>
                   
                    <div class="ect" v-if="getInfoAvatars(user.pages_access).length > 4" @click.stop="addPage(user.id)"><i class="fa-regular fa-ellipsis"></i></div>

                    <div class="plus" v-else @click.stop="addPage(user.id)">
                        <i class="fa-solid fa-plus"></i>
                    </div>
                </div>

                <div class="btn-outline-primary icon-l" @click.stop="startEditUser(user.id)">
                    <i class="fa-solid fa-pen"></i>
                    <span>{{ $t("dash.button.edit") }}</span>
                </div>
                <ContextMenu :options="getOptionsContextMenu(user.id)" :id="user.id" v-on:clickOption="clickOptionContextMenu">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                </ContextMenu>
                
            </div>    
        </div>

        <AddUserPopup v-if="displayAddPopUpUser" :display="displayAddPopUpUser" @closePopUp="closeAddPopUpUser" :pages_access="pages_access" :groups="groups" @submit="addUser" :roles="infoUser.role" :isAdmin="infoUser.admin" :emailExist="emailExist"></AddUserPopup>

        <AddUserPopup v-if="displayEditPopUpUser" :display="displayEditPopUpUser" @closePopUp="closeAddPopUpUser" :pages_access="pages_access" :groups="groups" @submit="editUser" :roles="infoUser.role" :isAdmin="infoUser.admin" :emailExist="emailExist" :data="dataEditUser" :stateCarrouselDefault="stateCarrouselDefault"></AddUserPopup>
    </div>
</template>

<script>
import Checkbox from '../utils/checkbox.vue';
import Avatar from '../utils/avatar.vue';
import AddUserPopup from './add-user-popup.vue';
import Tooltip from '../tooltip/tooltipInit.vue';
import ContextMenu from '../contextMenu/contextMenuInit.vue'

import SettingsMixin from '../../mixins/Settings.vue';
import UserMixin from '../../mixins/User.vue';
import SubscriptionsMixin from '../../mixins/Subscriptions.vue';
import CommonMixin from '../../mixins/Common.vue';

import store from './../../../store/index.js';
import { EventBus } from '@/event-bus';
import { mfaFeatureEnabled } from '@/utils/environment';

export default {
    name: 'users-settings',

    mixins: [SettingsMixin,UserMixin,SubscriptionsMixin,CommonMixin],

    components : {
        Checkbox,
        Avatar,
        AddUserPopup,
        Tooltip,
        ContextMenu
    },

    props : {
        pages_access : Array,
        groups : Array,
        infoUser : Object,
    },

    data() {
        return {
            users : [],
            SelectUser: [],
            displayAddPopUpUser : false,
            displayEditPopUpUser : false,
            dataEditUser: {},
            sortBy : 'email',
            stateCarrouselDefault : 1,
            valueInputSearch : "",
        };
    },

    async mounted() {
        EventBus.$on('handlerChangePlan', this.handlerChangePlan);

        this.listUsers({}).then(res => {
                const { success, users } = res.body

                if (success !== true || 'error' in res.body) {
                    console.log('error',res)
                    return 
                }

                this.users = users
                localStorage.setItem('users', JSON.stringify(this.users))
               

               
        }).catch(this.handleError)

    },

    methods: {
        getInfoAvatars(idPages) {
            if (!idPages) idPages = []

            let infoPage = []
            idPages.forEach(idPage => {

                let page = Array.isArray(this.pages_access) ? this.pages_access.find(p => p.id == idPage) : null

                if (page) {
                    infoPage.push({
                        avatar : page.avatar,
                        network : page.network
                    })
                }
            });
            return infoPage
        },

        getUsersWithFilter() {
            let users = []
            if(this.users){
                users = this.users
               
                if (this.infoUser && !this.infoUser.admin) {
                    //if role editor (!admin & no role)
                    if((!this.infoUser.role || this.infoUser.role.length == 0)) {
                        users = this.users.filter(user => 
                            ((user.pages_access && user.pages_access.every(pageId => this.infoUser.pages_access.find(p => p == pageId))) &&
                            (user.role && user.role.length && (user.role.includes('Viewer') || user.role.includes('Writter')))) || user.id == this.infoUser.id) 
                    }else{
                        //if role Writter
                        users = this.users.filter(user => 
                            ((user.pages_access && user.pages_access.every(pageId => this.infoUser.pages_access.find(p => p == pageId))) &&
                            (user.role && user.role.length && user.role.includes('Viewer'))) || user.id == this.infoUser.id) 
                    }
                }
                
                   
                return users.filter(user => this.isUserMatchingFilter(user));
            }
            return users
            
        },

        isUserMatchingFilter(user) {
            return user.email.trim().toLowerCase().indexOf(this.valueInputSearch.trim().toLowerCase()) >= 0 || user.lastname.trim().toLowerCase().indexOf(this.valueInputSearch.trim().toLowerCase()) >= 0 || user.firstname.trim().toLowerCase().indexOf(this.valueInputSearch.trim().toLowerCase()) >= 0;
        },

        setSortBy(value) {
            this.sortBy = value
        },

        emailExist(email) {
            let user = this.users.find(user => user.email == email)

            if (user) return true;
            return false;
        },

        addAllUser() {
            this.SelectUser = this.users.map(user => user.id);
        },
  
        removeAllUser() {
            this.SelectUser = []
        },

        addSelectUser(idUser) {
            if(!this.SelectUser.includes(idUser)) {
                this.SelectUser.push(idUser)
            }
        },

        removeSelectUser(idUser) {
            this.SelectUser = this.SelectUser.filter(id => id !== idUser)
        },

        closeAddPopUpUser() {
            console.log("closeAddPopUpUser")
            this.displayAddPopUpUser = false;
            this.displayEditPopUpUser = false;
            this.stateCarrouselDefault = 1;
        },

        startAddUser() {
            if (Object.values(this.plans)[this.infoUser._premium.plan].condition.user(this.users.filter(u => !u.role || u.role.length == 0 || !u.role.includes("Viewer")).length+1)) {
                this.displayAddPopUpUser = true;
            }else{
                EventBus.$emit("showModal", "Information", `Il semble que vous ayez atteint le nombre maximal d'utilisateurs autorisés selon votre forfait actuel.`, "Fermer", "Changer d'offre", null, "handlerChangePlan");
            }
      
        },

        handlerChangePlan(){
            this.$router.push('/dash/plan');
        },
       
        startEditUser(idUser) {
            console.log("azertyui",this.users)

            const user =  this.users.find((user) => user.id == idUser);
            console.log("test find user",user)
            if (user) {
                this.dataEditUser = {
                    id : idUser,
                    form : {
                        firstname : user.firstname,
                        lastname: user.lastname,
                        email: user.email,
                        role: user.admin ? 'Admin' : (!user.role || user.role.length == 0 ) ? 'Editor' : user.role[0],
                    },
                    selectPage : user.pages_access ? [...new Set([...user.pages_access])] : []

                }

                if (user.notifications) {
                    this.dataEditUser.form.alertEchec = user.notifications.error && (user.notifications.error === 'true' || user.notifications.error === true) ? true : false;
                    this.dataEditUser.form.alertValidation = user.notifications.info && (user.notifications.info === 'true' || user.notifications.info === true) ? true : false;
                    this.dataEditUser.form.alertInbox = user.notifications.inbox && (user.notifications.inbox === 'true' || user.notifications.inbox === true) ? true : false;
                    this.dataEditUser.form.alertPage = user.notifications.page && (user.notifications.page === 'true' || user.notifications.page === true) ? true : false;
                    this.dataEditUser.form.alertSource = user.notifications.source && (user.notifications.source === 'true' || user.notifications.source === true) ? true : false;
                }

                this.displayEditPopUpUser = true;
            }
        },

        addPage(idUser) {
            this.stateCarrouselDefault = 3;
            this.startEditUser(idUser)
        },

        async addUser(data){
            console.log("addUser",data)
            let body = {
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email.trim(),
                password: data.password,
                admin: data.role == 'Admin',
                account: `${this.infoUser.account}`,
                pages_access: data.selectPage,
                role: !['Admin', 'Editor'].includes(data.role) ? [data.role] : [],
                notifications: {
                  error: data.alertEchec,
                  info: data.alertValidation,
                  inbox: data.alertInbox,
                  page: data.alertPage,
                  source: data.alertSource
                }
            }

            this.createUser(body).then(res => {
            
                const { success, user } = res.body
            
                if (success !== true || 'error' in res.body) {

                    this.$vs.notify({
                        title: this.$t('dash.notifications.error_title'),
                        text: this.$t('dash.notifications.error_body'),
                        color:'error'
                    })
                    return alert(this.$t(res.body.error))
                }
        
                this.users = [user,...this.users]
                localStorage.setItem('users', JSON.stringify(this.users));

                this.closeAddPopUpUser()

                this.$vs.notify({
                    title: this.$t('dash.notifications.success_title'),
                    text: this.$t('dash.notifications.user_created'),
                    color:'success'
                })

                let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
                this.addLog(JSON.parse(localStorage.user), 'create-user', messageLog)

            }).catch(this.handleError)
            
        },

        async editUser(data){

            let body = {
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email.trim(),
                admin: data.role == 'Admin',
                id: this.dataEditUser.id,
                pages_access: data.selectPage,
                role: !['Admin', 'Editor'].includes(data.role) ? [data.role] : [],
                'notifications[error]' : data.alertEchec,
                'notifications[info]' : data.alertValidation,
                'notifications[inbox]' : data.alertInbox,
                'notifications[page]' : data.alertPage,
                'notifications[source]' : data.alertSource,
            }

            if (data.password && data.password !== "") body.password = data.password 
            // TODO when enable !
            console.log("editUser",body)
            this.updateUser(body).then(res => {
                const { success, user } = res.body
                console.log("res edit user",res.body)
                
                if (success !== true || 'error' in res.body) {
                    this.$vs.notify({
                        title: this.$t('dash.notifications.error_title'),
                        text: this.$t('dash.notifications.error_body'),
                        color:'error'
                    })
                    return
                }

                let updatedUser = this.users.find(element => element.id === user.id)

                let index = this.users.indexOf(updatedUser)
                this.$set(this.users, index, user)
                localStorage.setItem('users', JSON.stringify(this.users))

                //si l'utilisateur est nous meme
                if (this.currentUser.id == user.id) {
                    this.$store.commit('users/setCurrentUser', {
                        ...this.currentUser,
                        ...user
                    });
                    this.$store.dispatch('selectPage/fetchData');
                }



                this.$vs.notify({
                    title: this.$t('dash.notifications.success_title'),
                    text: this.$t('dash.notifications.user_updated'),
                    color:'success'
                })
                this.closeAddPopUpUser()
                
                let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
                this.addLog(JSON.parse(localStorage.user), 'update-user', messageLog)
      
            }).catch(this.handleError)
        },

        async removeUserSelected(){

            let idPassed = [];


            const removePromises = this.SelectUser.map(idUser => {
                return this.removeUser(idUser)
                    .then(res => {
                        const { success } = res.body;
                        if (success !== true || 'error' in res.body) {
                            console.log(res);
                        } else {
                            idPassed.push(idUser);
                        }

                        let messageLog = `${res.url} --- ${JSON.stringify(idUser)} --- ${res.bodyText}`
                        this.addLog(JSON.parse(localStorage.user), 'remove-user', messageLog)
                    })
                    .catch(this.handleError);
            });

            Promise.all(removePromises)
                .then(() => {
                    this.users = this.users.filter(user => !idPassed.includes(user.id));
                    this.SelectUser = this.SelectUser.filter(idUser => !idPassed.includes(idUser));
                    localStorage.setItem('users', JSON.stringify(this.users))

                    this.$vs.notify({
                        title: this.$t('dash.notifications.success_title'),
                        color:'success'
                    })
        
                })
                .then(this.listUsers({}))
                .then(res => {
                    const { success, users } = res.body

                    if (success !== true || 'error' in res.body) {
                        console.log('error',res)
                        return 
                    }

                    this.users = users
                    localStorage.setItem('users', JSON.stringify(this.users))                
                })
                .catch(error => {
                    this.$vs.notify({
                        title: this.$t('dash.notifications.error_title'),
                        text: this.$t('dash.notifications.error_body'),
                        color:'error'
                    })
                });
        },

        async deleteUser(idUser) {
            this.removeUser(idUser)
                .then(res => {
                        const { success } = res.body;
                        if (success !== true || 'error' in res.body) {
                            this.$vs.notify({
                                title: this.$t('dash.notifications.error_title'),
                                text: this.$t('dash.notifications.error_body'),
                                color:'error'
                            })
                        }else{
                            this.users = this.users.filter(user => user.id !== idUser);
                            localStorage.setItem('users', JSON.stringify(this.users));
                            this.$vs.notify({
                                title: this.$t('dash.notifications.success_title'),
                                color:'success'
                            })

                            let messageLog = `${res.url} --- ${JSON.stringify(idUser)} --- ${res.bodyText}`
                            this.addLog(JSON.parse(localStorage.user), 'remove-user', messageLog)
                        }
                })
                .then(this.listUsers({}))
                .then(res => {
                    const { success, users } = res.body

                    if (success !== true || 'error' in res.body) {
                        console.log('error',res)
                        return 
                    }

                    this.users = users
                    localStorage.setItem('users', JSON.stringify(this.users))                
                })
                .catch(this.handleError);
        },        

        getViewerLoginUrl(id) {

            this.getViewerUrl(id).then(res => {
                if(res.body && res.body.success && res.body.url) {

                    this.copyViewerUrl(res.body.url)
                    // notif copy en presse papier 
                    alert("ok copy link")
                }else {
                // notif error
                    alert("error copy link")
                }
            })
        },

        copyViewerUrl(url) {
            const el = document.createElement('textarea');  
            el.value = url;                                 
            el.setAttribute('readonly', '');                
            el.style.position = 'absolute';                     
            el.style.left = '-9999px';                      
            document.body.appendChild(el);                  
            const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
            el.select();                                    
            document.execCommand('copy');                   
            document.body.removeChild(el);                  
            if (selected) {                                 
                document.getSelection().removeAllRanges();    
                document.getSelection().addRange(selected);   
            }
        },

        clickOptionContextMenu(idContextMenu, nameOption) {
            switch (nameOption) {
                case 'deleteUser':
                    this.deleteUser(idContextMenu)
                    break;
                case 'edit':
                    this.startEditUser(idContextMenu)
                    break;
                case 'mfaReset':
                    this.confirmMfa(idContextMenu, 'reset')
                    break;
                case 'mfaRequire':
                    this.confirmMfa(idContextMenu, 'require')
                    break;
                case 'mfaUnrequire':
                    this.confirmMfa(idContextMenu, 'unrequire')
                    break;

                default:
                    break;
            }
        },

        getOptionsContextMenu(idUser) {
            let options = [{label: this.$t("dash.button.edit"), name : 'edit'}]
            let user = this.users.find(user => user.id == idUser);

            if (this.infoUser.admin) {
                options.push({label: this.$t("dash.button.delete"), name : 'deleteUser'})
            }

            if (user) {
                if (!user.confirmed_at) {
                    options.push({label: this.$t("dash.settings.user.send_invitation"), name : 'send'})
                }
                // Double authentification : réservé à l'admin du compte
                if (this.infoUser.admin && this.mfaEnabled) {
                    const mfa = user.mfa || {}
                    if (mfa.enabled && user.id !== this.infoUser.id) options.push({label: this.$t('mfa.users.reset'), name : 'mfaReset'})
                    options.push(mfa.required
                        ? {label: this.$t('mfa.users.unrequire'), name : 'mfaUnrequire'}
                        : {label: this.$t('mfa.users.require'), name : 'mfaRequire'})
                }
                return options
            }

            return null
        },

        confirmMfa(idUser, action) {
            const user = this.users.find(u => u.id == idUser)
            if (!user) return
            EventBus.$emit('showModal',
                this.$t(`mfa.users.${action}_title`),
                this.$t(`mfa.users.${action}_confirm`, { email: user.email }),
                this.$t('dash.button.validate'),
                this.$t('dash.button.cancel'),
                () => this.applyMfa(user, action))
        },

        async applyMfa(user, action) {
            const res = action === 'reset'
                ? await this.mfaResetUser(user.id)
                : await this.mfaRequireUser(user.id, action === 'require')
            if (!res.ok) {
                const key = res.body && res.body.error
                return this.$vs.notify({ title: this.$t('dash.notifications.error_title'), text: key && this.$te(key) ? this.$t(key) : this.$t('dash.notifications.error_body'), color: 'danger' })
            }
            const mfa = { ...(user.mfa || {}) }
            if (action === 'reset') mfa.enabled = false
            else mfa.required = action === 'require'
            this.$set(user, 'mfa', mfa)
            this.$vs.notify({ title: this.$t('dash.notifications.success_title'), text: this.$t(`mfa.users.${action}_done`), color: 'success' })
        },
    },
    
    computed: {
        mfaEnabled() {
            return mfaFeatureEnabled()
        },

        getUsersBySort() {
            return this.getUsersWithFilter().sort((user1, user2) => {
       
                let val1,val2;
                if(this.sortBy == 'role'){
                    val1 = user1.admin == true ? 'administrateur' : !user1.role || user1.role.length == 0 ? 'editeur' : user1.role[0].toLowerCase()
                    val2 = user2.admin == true ? 'administrateur' : !user2.role || user2.role.length == 0 ? 'editeur' : user2.role[0].toLowerCase()
                }else{
                    val1 = user1[this.sortBy].toLowerCase(); // Convertir en minuscules pour un tri insensible à la casse
                    val2 = user2[this.sortBy].toLowerCase();
                }      

                if (val1 < val2) {
                    return -1;
                } else if (val1 > val2) {
                    return 1;
                } else {
                    return 0;
                }
            
            });
        },


        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },
    },

    beforeDestroy () {
        EventBus.$off('handlerChangePlan', this.handlerChangePlan);
    }
};
</script>
<style lang="scss" scoped>
.mfa-user-icon {
    margin-left: 6px;
    font-size: 14px;
    &.on { color: #1e7b34; }
    &.pending { color: #b45309; }
}
</style>
